export const dataQueryStatus = {
  IDLE: "IDLE",
  DATAMODE: "DATAMODE",
  NULLMODE: "NULLMODE",
  ERROR: "ERROR",
  LOADING: "LOADING",
  SUCCESS: "SUCESS",
};
